import { Component, OnInit, Input, Inject } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-team-members-page',
  templateUrl: './team-members-page.component.html',
  styleUrls: ['./team-members-page.component.css']
})
export class TeamMembersPageComponent implements OnInit {

  @Input('$transition$') transition: any;

  iconClicked: any;
  managerObj: any;
  fromManagerCard: any;
  managers: any[] = [];
  currentManager: any;

  constructor(
    private storageService: StorageService,
    @Inject('$state') public $state: any
  ) { }

  ngOnInit() {
    if (this.transition) {
      const params = this.transition.params();
      this.iconClicked = params.iconClicked;
      this.managerObj = params.managerObj;
      this.fromManagerCard = params.fromManagerCard;
    }

    this.managers = this.storageService.get('managers') || [];

    if (this.fromManagerCard && this.managerObj !== null) {
      if (_.findIndex(this.managers, { userId: this.managerObj.userId }) === -1) {
        this.managers.push(this.managerObj);
        this.storageService.set('managers', this.managers, null);
      }
    }

    if (this.managerObj && !_.isEqual(this.managerObj, {}) && this.managerObj !== null) {
      this.iconClicked = null;
    }
  }

  viewManagerReportees(manager) {
    this.$state.go('missioncontrol.teamMembers',
      { managerObj: manager, userType: 'applicationUsers', fromManagerCard: false },
      { reload: true });
  }

  getAllUsers() {
    this.$state.go('missioncontrol.teamMembers',
      { managerObj: null, userType: 'applicationUsers' },
      { reload: false });
  }
}

